<template>
	<!-- Header -->
	<el-row>
		<el-col :span="24">
			<div class="base-form header">
				<h2 class="item" v-if="viewType == ViewType.Creating">
					Новый автомобиль
				</h2>
				<h2 class="item" v-else>
					Карточка автомобиля <span v-if="originVehicle?.model">{{ originVehicle?.model?.manufacturer?.name + ' ' + originVehicle?.model?.name }}</span>
				</h2>
			</div>
		</el-col>	
	</el-row>

	<div class="base-form">
		<el-row>
			<el-col :span="24">
				<!-- Creating a new vehicle mode -->
				<el-form v-if="viewType == ViewType.Creating" ref="form" v-loading="isAsyncOperationPending" :rules="rules" :model="ruleForm">
					<el-form-item label="Модель автомобиля" label-position="top" prop="model">
						<catalog-picker-component						
							ref="vehicleModel"
							auth 
							v-model="ruleForm.model"
							placeholder="Поиск автомобиля по модели или производителю"
							search-url="/api/vehicles/searchmodels"
							:catalog-tab="vehicleModelsCatalogTab"
							@catalog-item-picked="onVehicleModelPickedFromCatalog">
							<template #label>
								<text v-if="ruleForm.model?.id">
									{{ ruleForm.model?.manufacturer?.name + ' ' + ruleForm.model?.name }}
								</text>
							</template>
							<template #default="scope">
								{{ scope.manufacturer?.name + ' ' + scope.name }}
							</template>
						</catalog-picker-component>
					</el-form-item>

					<el-form-item label="Собственник" label-position="top" prop="counterparty">
						<catalog-picker-component				
							ref="counterparty"
							auth 
							v-model="ruleForm.counterparty"
							placeholder="Поиск контрагентов по инициалам, телефону"
							search-url="/api/counterparties/search"
							:catalog-tab="counterpartiesCatalogTab"
							@catalog-item-picked="onCounterpartyPickedFromCatalog">
							<template #label>
								<text v-if="ruleForm.counterparty?.id">
									{{ ruleForm.counterparty?.lastname + ' ' + ruleForm.counterparty?.firstname + (ruleForm.counterparty?.middlename ? ` ${ruleForm.counterparty.middlename}` : '') }} 
									{{ !!ruleForm.counterparty?.legalEntity?.name ? ` (${ruleForm.counterparty.legalEntity.name})` : '' }} 
								</text>
							</template>
							<template #default="scope">
								{{ scope.lastname + ' ' + scope.firstname + (scope.middlename ? ` ${scope.middlename}` : '') }} 
								{{ !!scope.legalEntity?.name ? ` (${scope.legalEntity.name})` : '' }}
							</template>
						</catalog-picker-component>
					</el-form-item>

					<el-form-item label="VIN" label-position="top" prop="vin">					
						<el-input
							:maxlength="50" 
							:formatter="vinFormatter"							
							v-model="ruleForm.vin"						
							@keyup.enter="onDecodeVinClick"
							placeholder="VIN">
							<template #append>								
								<el-link :underline="false" :disabled="!isVinCodeValid() || isAsyncDecodeVinOperationPending">
									<el-icon @click="onDecodeVinClick">
										<Edit />
									</el-icon>
								</el-link>
							</template>
						</el-input>
					</el-form-item>

					<el-form-item label="Гос. номер" label-position="top" prop="govno">
						<el-input v-model="ruleForm.govNo"/>
					</el-form-item>

					<el-form-item label="Дата производства автомобиля" label-position="top" prop="production">
						<el-date-picker
							v-model="ruleForm.productionDate"
							:clearable="false"
							format="DD.MM.YYYY"
							type="date"
							placeholder="Укажите дату"
						/>					
					</el-form-item>

					<el-form-item label="Модельный ряд (год)" label-position="top" prop="modelYear">					
						<el-input-number v-model="ruleForm.modelYear" :controls="false" :min="1900" :max="nowYear" />
					</el-form-item>

					<el-form-item label="Двигатель" label-position="top" prop="productionYear">					
						<el-input
							v-model="ruleForm.engine"
							:rows="2"
							type="textarea"
							maxlength="255"
							placeholder="Двигатель"
							resize="none"
							clearable
							show-word-limit
						/>
					</el-form-item>

					<el-form-item label="Трансмиссия" label-position="top" prop="productionYear">					
						<el-input
							v-model="ruleForm.transmission"
							:rows="2"
							type="textarea"
							maxlength="255"
							placeholder="Трансмиссия"
							resize="none"
							clearable
							show-word-limit
						/>
					</el-form-item>

					<el-form-item>
						<el-row>
							<el-col :span="24">
								<el-button type="primary" @click="onFormSubmitClick">
									Создать
								</el-button>	
								&nbsp;		
								<el-button type="warning" @click="onFormCancelClick">
									Очистить форму
								</el-button>
							</el-col>							
						</el-row>
					</el-form-item>
				</el-form>

				<!-- Editing existing vehicle mode -->
				<el-form v-if="viewType == ViewType.Editing" ref="form" v-loading="isAsyncOperationPending" :rules="rules" :model="ruleForm">
					<el-form-item label="Модель автомобиля" label-position="top" prop="model">
						<catalog-picker-component
							:disabled="ruleForm.ownerWasChanged"
							ref="vehicleModel"
							auth 
							v-model="ruleForm.model"
							placeholder="Поиск автомобиля по модели или производителю"
							search-url="/api/vehicles/searchmodels"
							:catalog-tab="vehicleModelsCatalogTab"
							@catalog-item-picked="onVehicleModelPickedFromCatalog">
							<template #label>
								<text v-if="ruleForm.model?.id">
									{{ ruleForm.model?.manufacturer?.name + ' ' + ruleForm.model?.name }}
								</text>
							</template>
							<template #default="scope">
								{{ scope.manufacturer?.name + ' ' + scope.name }}
							</template>
						</catalog-picker-component>
					</el-form-item>

					<el-form-item label="Собственник" label-position="top" prop="counterparty">
						<catalog-picker-component 
							:disabled="ruleForm.ownerWasChanged"
							ref="counterparty"
							auth 
							v-model="ruleForm.counterparty"
							placeholder="Поиск контрагентов по инициалам, телефону"
							search-url="/api/counterparties/search"
							:catalog-tab="counterpartiesCatalogTab"
							@catalog-item-picked="onCounterpartyPickedFromCatalog">
							<template #label>
								<text v-if="ruleForm.counterparty?.id">
									{{ ruleForm.counterparty?.lastname + ' ' + ruleForm.counterparty?.firstname + (ruleForm.counterparty?.middlename ? ` ${ruleForm.counterparty.middlename}` : '') }} 
									{{ !!ruleForm.counterparty?.legalEntity?.name ? ` (${ruleForm.counterparty.legalEntity.name})` : '' }}
								</text>
							</template>
							<template #default="scope">
								{{ scope.lastname + ' ' + scope.firstname + (scope.middlename ? ` ${scope.middlename}` : '') }} 
								{{ !!scope.legalEntity?.name ? ` (${scope.legalEntity.name})` : '' }}
							</template>
						</catalog-picker-component>
					</el-form-item>

					<el-form-item label="VIN" label-position="top" prop="vin">					
						<el-input
							:disabled="ruleForm.ownerWasChanged || isAsyncDecodeVinOperationPending"
							:maxlength="50" 
							:formatter="vinFormatter"
							v-model="ruleForm.vin"
							placeholder="VIN">
							<template #append>
								<el-link :underline="false" :disabled="ruleForm.vin == originVehicle?.vin || !isVinCodeValid() || isAsyncDecodeVinOperationPending">
									<el-icon @click="onDecodeVinClick">
										<Edit />
									</el-icon>
								</el-link>
							</template>
						</el-input>
					</el-form-item>

					<el-form-item label="Гос. номер" label-position="top" prop="govno">
						<el-input v-model="ruleForm.govNo" :disabled="ruleForm.ownerWasChanged" />
					</el-form-item>

					<el-form-item label="Дата производства автомобиля" label-position="top" prop="production">
						<el-date-picker
							:disabled="ruleForm.ownerWasChanged"
							v-model="ruleForm.productionDate"
							:clearable="false"
							type="date"
							format="DD.MM.YYYY"
							placeholder="Укажите дату"
						/>
					</el-form-item>

					<el-form-item label="Модельный ряд (год)" label-position="top">
						<el-input-number :disabled="ruleForm.ownerWasChanged" v-model="ruleForm.modelYear" :controls="false" :min="1900" :max="nowYear" />
					</el-form-item>

					<el-form-item label="Двигатель" label-position="top">					
						<el-input
							v-model="ruleForm.engine"
							:rows="2"
							type="textarea"
							maxlength="255"
							placeholder="Двигатель"
							resize="none"
							clearable
							show-word-limit
						/>
					</el-form-item>

					<el-form-item label="Трансмиссия" label-position="top">					
						<el-input
							v-model="ruleForm.transmission"
							:rows="2"
							type="textarea"
							maxlength="255"
							placeholder="Трансмиссия"
							resize="none"
							clearable
							show-word-limit
						/>
					</el-form-item>

					<el-form-item label="Текущий пробег (км)" label-position="top">
						<el-input-number :disabled="ruleForm.ownerWasChanged" v-model="ruleForm.mileage" :min="0" :controls="false" />
					</el-form-item>

					<el-form-item>
						<el-checkbox label="Новый собственник" v-model="ruleForm.ownerWasChanged" @change="onFormOwnerChangedChange" />
					</el-form-item>	
					
					<el-form-item>
						<el-row style="width: 100%;">
							<el-col :span="16">
								<el-button type="primary" @click="onFormSubmitClick">
									Сохранить
								</el-button>	
								<el-button type="warning" @click="onFormCancelClick">
									Отменить изменения
								</el-button>
							</el-col>
							<el-col :span="8">
								<div style="text-align: right;">
									<el-button type="danger"
										:disabled="!isViewLoaded && isAsyncOperationPending || !isVehicleDeletionAllowed" 
										@click="onDeleteVehicleClick">
										Удалить автомобиль
									</el-button>
								</div>
							</el-col>
						</el-row>
						<el-row style="width: 100%;">
							<el-col :span="16">
								&nbsp;
							</el-col>
							<el-col :span="8">
								<div v-if="isViewLoaded && !isVehicleDeletionAllowed" style="text-align: right; line-height: 1rem; margin-top: 1rem; width: 100%;">
									<el-text type="info" size="small">
										<el-icon><Opportunity /></el-icon>
										Нельзя удалить - по автомобилю проводились работы в заказ-нарядах
									</el-text>
								</div>
							</el-col>
						</el-row>
					</el-form-item>
				</el-form>
			</el-col>		
		</el-row>
	</div>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';
import { CirclePlus, Edit, Opportunity } from '@element-plus/icons-vue';
import { ElTable, ElTag, ElLink, ElForm, FormInstance, ElNotification, ElMessageBox } from 'element-plus';
import { reactive } from 'vue';
import VehicleModel from '@/models/VehicleModel';
import CounterpartyModel from '@/models/CounterpartyModel';
import CatalogPickerComponent from '@/components/CatalogPickerComponent.vue';
import store from '@/store';
import EventHelper from '@/helpers/eventsHelper';
import Vehicle from '@/models/Vehicle';
import OrderApiHelper from '@/helpers/api/OrderApiHelper';
import VehicleApiHelper from '@/helpers/api/VehicleApiHelper';
import TabsDictionary from '@/variables/tabs';
import ViewType from '@/models/enums/ViewType';

interface IVehicleRequest {
	id: number;
	model: VehicleModel | null;
	counterparty: CounterpartyModel | null;
	vin: string;
	govNo: string | null,
	productionDate: Date | null,
	mileage: number,
	ownerWasChanged: boolean,

	modelYear: number | null,
	engine: string | null,
	transmission: string | null,
}

@Options({
	components: {
		CirclePlus, ElForm, ElTable, ElTag, ElLink,
		Opportunity, Edit,
		CatalogPickerComponent 
	},
	props: {
		params: Array
	}
})
export default class VehicleView extends Vue {
	/** props */
	params!: Array<any>;

	/** constants **/
	editIcon = Edit;
	vinRegex = /^[A-z0-9]{17,17}$/;
	vehicleApi = new VehicleApiHelper();
	ViewType = ViewType;
	nowYear = new Date().getFullYear();	
	counterpartiesCatalogTab = TabsDictionary.counterparties;
	vehicleModelsCatalogTab = TabsDictionary.vehicleModels;
	orderApiHelper = new OrderApiHelper(store.getters.jwt);

	/** view-models */	
	originVehicle: Vehicle | null = null;	
	viewType: ViewType = this.ViewType.Viewing;
	isViewLoaded = false;
	isVehicleDeletionAllowed = false;
	isAsyncOperationPending = false;
	isAsyncDecodeVinOperationPending = false;
	ruleForm: IVehicleRequest = {
		id: 0,
		model: null,
		counterparty: null,
		vin: '',
		govNo: null,
		productionDate: null,
		modelYear: null,
		engine: null,
		transmission: null,
		mileage: 0,
		ownerWasChanged: false
	};

	rules = reactive({
		model: [
			{ required: true, message: 'Марка и модель должны быть указаны', trigger: 'click' }
		],
		counterparty: [
			{ required: true, message: 'Контрагент должен быть указан', trigger: 'click' }
		],
		vin: [
			{ required: true, validator: async (_: any, b: string, c: Function) => await this.vinValidator(_, b, c), trigger: 'blur' }
		],
		govno: [
			{ required: false, validator: async (_: any, b: string | null, c: Function) => this.govNoValidator(_, b, c), trigger: 'blur' }
		],
		production: [
			{ required: true, validator: async (_: any, b: Date | null, c: Function) => this.productionDateValidator(_, b, c), trigger: 'blur' }
		]
	});

	mounted() {			
		const vehicle = this.params?.length && this.params[1] === true ? this.params[0] as Vehicle : undefined;
		this.initView(vehicle?.id);
	}

	onVehicleModelPickedFromCatalog(vehicleModel: VehicleModel) {
		const vehicleModelPickerComponent = this.$refs.vehicleModel as any;
		vehicleModelPickerComponent?.set(vehicleModel);		
	}

	onCounterpartyPickedFromCatalog(counterparty: CounterpartyModel) {
		const counterpartyPickerComponent = this.$refs.counterparty as any;
		counterpartyPickerComponent?.set(counterparty);		
	}

	initView(vehicleId?: number) {
		if (!vehicleId) {
			this.viewType = ViewType.Creating;
		}
		else {
			this.viewType = ViewType.Editing;
			this.isAsyncOperationPending = true;
			this.loadVehicle(vehicleId)
				.then(async vehicle => {

				if (!vehicle?.id) {
					ElNotification({
						message: 'Ошибка загрузки карточки автомобиля',
						type: 'error',
					});
					return;
				}

				this.originVehicle = vehicle;

				this.ruleForm.id = this.originVehicle.id;
				this.ruleForm.vin = this.originVehicle.vin;
				this.ruleForm.govNo = this.originVehicle.govermentalNumber;
				this.ruleForm.mileage = this.originVehicle.mileage;
				this.ruleForm.productionDate = this.originVehicle.productionDate;
				this.ruleForm.ownerWasChanged = this.originVehicle.ownerChanged;
				this.ruleForm.modelYear = this.originVehicle.modelYear;
				this.ruleForm.engine = this.originVehicle.engine;
				this.ruleForm.transmission = this.originVehicle.transmission;
				
				await this.$nextTick();
				const vehicleModelPickerComponent = this.$refs.vehicleModel as any;
				const counterpartyPickerComponent = this.$refs.counterparty as any;
				vehicleModelPickerComponent.set(this.originVehicle!.model);
				counterpartyPickerComponent.set(this.originVehicle!.counterparty);		
				
				const vehicleOrders = await this.orderApiHelper.getOrdersByVehicleAsync(vehicle.id);
				this.isVehicleDeletionAllowed = vehicleOrders!.length == 0;
			}).finally(() => {
				this.isAsyncOperationPending = false;
				this.isViewLoaded = true;
			})
		}
	}

	onFormSubmitClick() {		
		const form = this.$refs.form as FormInstance;
		form.validate(async (valid) => {
			if (!valid) {
				return;
			}

			const vehicleRequest = {
				id: this.ruleForm.id,
				modelId: this.ruleForm.model!.id,
				counterpartyId: this.ruleForm.counterparty!.id,
				vin: this.ruleForm.vin,
				govermentalNumber: this.ruleForm.govNo,
				mileage: this.ruleForm.mileage,
				ownerWasChanged: this.ruleForm.ownerWasChanged,
				productionDate: this.ruleForm.productionDate,
				modelYear: this.ruleForm.modelYear,
				engine: this.ruleForm.engine,
				transmission: this.ruleForm.transmission
			};
	
			const creatingMode = this.viewType == ViewType.Creating;
			const vehicleAsyncOperationHandler = creatingMode ? this.createVehicle : this.updateVehicle;
			
			try {		
				this.isAsyncOperationPending = true;
				const response = await vehicleAsyncOperationHandler(vehicleRequest);

				if (response != null) {
					EventHelper.dispatchEvent('ordersListUpdate');
					ElNotification({
						message: `Автомобиль ${this.ruleForm.model!.manufacturer!.name} ${this.ruleForm.model!.name} успешно ${creatingMode ? 'создан' : 'изменен'}`,
						type: 'success',
					});

					if (this.viewType == ViewType.Creating) {
						this.initView(response.id);
					} else {
						this.initView(this.originVehicle!.id);
					}
				} else {
					throw new Error();
				}
			}
			catch {
				ElNotification({
					message: `Ошибка ${(creatingMode ? 'создания' : 'изменения')} автомобиля ${this.ruleForm.model!.manufacturer!.name} ${this.ruleForm.model!.name}`,
					type: 'error',
				});
			} finally {
				this.isAsyncOperationPending = false;
			}
		});
	}

	onFormCancelClick() {
		ElMessageBox.confirm(
				'Все несохраненные данные буду потеряны. Продолжить ?',
				{
					confirmButtonText: 'OK',
					cancelButtonText: 'Отмена',
					type: 'warning',
					confirmButtonClass: 'messagebox-danger-button'
				}
			)
			.then(() => {				
				if (this.viewType == ViewType.Creating) {
					this.ruleForm.id = 0;
					this.ruleForm.model = null;
					this.ruleForm.counterparty = null;
					this.ruleForm.vin = '';
					this.ruleForm.govNo = null;
					this.ruleForm.productionDate = null;
					this.ruleForm.mileage = 0;
					this.ruleForm.modelYear = null;
					this.ruleForm.engine = null;
					this.ruleForm.transmission = null;

					this.$nextTick()
						.then(() =>{
							(this.$refs.vehicleModel as any).set(null);
							(this.$refs.counterparty as any).set(null);
						});
						
				} else {
					this.ruleForm.vin = this.originVehicle!.vin;
					this.ruleForm.govNo = this.originVehicle!.govermentalNumber;
					this.ruleForm.mileage = this.originVehicle!.mileage;
					this.ruleForm.ownerWasChanged = this.originVehicle!.ownerChanged;
					this.ruleForm.mileage = this.originVehicle!.mileage;
					this.ruleForm.modelYear = this.originVehicle!.modelYear;
					this.ruleForm.engine = this.originVehicle!.engine;
					this.ruleForm.transmission = this.originVehicle!.transmission;

					this.$nextTick()
						.then(() =>{
							(this.$refs.vehicleModel as any).set(new VehicleModel(this.originVehicle!.model));
							(this.$refs.counterparty as any).set(new CounterpartyModel(this.originVehicle!.counterparty));
						});
				}


			});
	}

	onFormOwnerChangedChange() {
		const originV = this.originVehicle!;
		this.ruleForm.vin = originV.vin;
		this.ruleForm.govNo = originV.govermentalNumber;
		this.ruleForm.mileage = originV.mileage;
	}

	onDeleteVehicleClick() {
		this.orderApiHelper
			.getOrdersByVehicleAsync(this.originVehicle!.id)
			.then(orders => {
				if (orders!.length != 0) {
					ElMessageBox.confirm(
						'Удаление невозможно, у автомобиля есть заказ-наряды', {
						confirmButtonText: 'OK',
						type: 'error',
					});
				} else {
					const vehicle = this.originVehicle!;
					ElMessageBox.confirm(
						`Автомобиль ${vehicle.model!.manufacturer!.name} ${vehicle.model!.name} будет удален`, {
						confirmButtonText: 'OK',
						cancelButtonText: 'Отмена',
						type: 'warning',
					})
					.then(() => this.deleteVehicleAsync(vehicle));
				}
			});
	}

	createVehicle(request: any) : Promise<Vehicle | null> {
		return this.vehicleApi.createAsync(store.getters.jwt, request);
	}

	loadVehicle(id: number) {
		return this.vehicleApi.getVehicleByIdAsync(store.getters.jwt, id);
	}

	updateVehicle(request: any) : Promise<Vehicle | null> {
		return this.vehicleApi.updateAsync(store.getters.jwt, request);
	}

	async deleteVehicleAsync(vehicle: Vehicle) {
		this.isAsyncOperationPending = true;
		const isDeleted = await this.vehicleApi.deleteVehicleAsync(store.getters.jwt, vehicle.id);
		if (isDeleted) {
			this.closeCurrentTab();
			ElNotification({				
				message: `Автомобиль ${vehicle.model?.manufacturer?.name} ${vehicle.model?.name} удален`,
				type: 'success',
			});
		} else {
			ElNotification({				
				message: `Ошибка удаления автомобиля ${vehicle.model?.manufacturer?.name} ${vehicle.model?.name}`,
				type: 'error',
			});
		}
		this.isAsyncOperationPending = false;
	}

	closeCurrentTab() {		
		store.commit('removeTab', store.getters.tab);
	}

	vinFormatter(vaule: string) {		
		const vinRegex = /[A-z0-9]*/;
		const mathches = vaule.match(vinRegex);
		if (mathches?.length) {
			return mathches[0];
		}

		return null;
	}

	onDecodeVinClick() {	
		if (this.ruleForm.vin == this.originVehicle?.vin) {
			return;
		}

		if (this.isAsyncDecodeVinOperationPending) {
			return;
		}

		if (!this.isVinCodeValid()) {
			return;
		}

		this.isAsyncDecodeVinOperationPending = true;
		this.vehicleApi.decodeVinAsync(store.getters.jwt, this.ruleForm.vin)
			.then(decodedVehicle => {
				if (!decodedVehicle?.model?.id) {
					ElNotification({
						message: 'Ошибка расшифровки VIN',
						type: 'error',
					});
					return;
				}

				this.ruleForm.model = decodedVehicle.model;
				this.ruleForm.engine = decodedVehicle.engine;
				this.ruleForm.transmission = decodedVehicle.transmission;
				this.ruleForm.modelYear = decodedVehicle.modelYear;		
				if (decodedVehicle.productionDate) {
					this.ruleForm.productionDate = decodedVehicle.productionDate;
				}

				this.$nextTick()
					.then(() => (this.$refs.vehicleModel as CatalogPickerComponent).set(new VehicleModel(this.ruleForm.model)));
			})
			.finally(() => this.isAsyncDecodeVinOperationPending = false);
	}

	isVinCodeValid() {
		return this.vinRegex.test(this.ruleForm.vin);
	}

	async vinValidator(_: any, vin: string, callback: Function) {		
		if (this.ruleForm.ownerWasChanged) {
			return;
		}

		if (!this.isVinCodeValid()) {
			callback(new Error('Некорректный VIN'));
			return false;
		}

		try {
			const vehicle = await this.vehicleApi.getVehicleByVinAsync(store.getters.jwt, vin);
			if (!vehicle?.id) {
				return true;
			} 
			
			if (vehicle.id != this.ruleForm.id) {
				callback(new Error('VIN уже существует'));
				return false;
			}

			return true;			
		} catch {
			return true;
		}
	}

	productionDateValidator(_: any, __: Date | null, callback: Function) {
		if (this.ruleForm.ownerWasChanged) {
			return true;
		}

		if (!this.ruleForm.productionDate) {
			callback(new Error('Дата выпуска автомобиля должна быть указана'));
			return false;
		}

		const now = new Date();	
		const pDate = this.ruleForm.productionDate;
		if (pDate > now ||
			(pDate.getDate() == now.getDate() && pDate.getMonth() == now.getMonth() && pDate.getFullYear() == now.getFullYear())) {
			callback(new Error('Некорректная дата выпуска автомобиля'));
			return false;
		}
	}

	govNoValidator(_: any, govNo: any, callback: Function) {
		if (this.ruleForm.ownerWasChanged) {
			return true;
		}

		if (!this.ruleForm.govNo?.length) {
			return true;
		}

		if (this.ruleForm.govNo.length < 6) {
			callback(new Error('Некорректный гос. номер автомобиля'));
			return false;
		}
	}
	
}
</script>

<style scoped>
.messagebox-danger-button {
	border-color: var(--el-color-error);
	background: var(--el-color-error-light-3);
}

	.messagebox-danger-button:hover {
		border-color: var(--el-color-error);
		background: var(--el-color-danger);
	}
</style>